import * as React from 'react';
import NavigationItem from '../Sidebar/NavigationItem/NavigationItem';
var Submenu = function (props) {
    return (React.createElement("nav", { className: "submenu col-md-4" },
        React.createElement("ul", { className: "nav" }, props.menuItems.map(function (item) { return (React.createElement(NavigationItem
        // @ts-ignore
        , { 
            // @ts-ignore
            id: item.id, key: item.id, exact: item.exact, relative: true, link: item.link },
            "\u00A0",
            item.name)); }))));
};
export default Submenu;



//////////////////
// WEBPACK FOOTER
// ./src/components/Submenu/Submenu.tsx
// module id = 22
// module chunks = 0